import { render, staticRenderFns } from "./LinkedDealerSelector.vue?vue&type=template&id=9b22e4ec"
import script from "./LinkedDealerSelector.vue?vue&type=script&lang=js"
export * from "./LinkedDealerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports